module.exports = __webpack_public_path__ + "static/media/Lidw.3ffb51b7.jpeg";